export const formatISBN = (isbn) => {
    if (isbn === undefined || isbn === null) return '';

    const str = isbn.toString().replace(/[^0-9X]/gi, '');
  
    // Retire les espaces ou tirets éventuels déjà présents
    const clean = str.replace(/[^0-9X]/gi, '');
  
    // Format basique pour ISBN-13 (ex: 978-2-08-130349-2)
    if (clean.length === 13) {
      return `${clean.slice(0, 3)}-${clean.slice(3, 4)}-${clean.slice(4, 6)}-${clean.slice(6, 12)}-${clean.slice(12)}`;
    }
  
    // Pour ISBN-10 si jamais tu en as (ex: 2-07-036822-X)
    if (clean.length === 10) {
      return `${clean.slice(0, 1)}-${clean.slice(1, 4)}-${clean.slice(4, 9)}-${clean.slice(9)}`;
    }
  
    return isbn; // Si ça ne matche pas, on retourne tel quel
  };
  